import React, { useCallback, useState } from 'react';
import { TypedMemo } from '../../../common/types';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the Social block; each part uses its own slice of it */
import styles from './SocialBlock.module.scss';
/* eslint-enable css-modules/no-unused-class */

interface SocialPostThumbProps {
  /** The image address that the platform gave, or null. */
  url: string | null;
}

/**
 * The thumbnail of a post. A post with no image, and an image that does not load (a platform
 * address stops to work after some time), shows the striped box of the design.
 */
const SocialPostThumbComponent: React.FC<SocialPostThumbProps> = ({ url }) => {
  const [hasFailed, setHasFailed] = useState(false);
  const markFailed = useCallback(() => setHasFailed(true), []);

  return (
    <span className={styles.thumb} data-testid="social-post-thumb">
      {url !== null && !hasFailed && (
        <img src={url} alt="" loading="lazy" referrerPolicy="no-referrer" onError={markFailed} />
      )}
    </span>
  );
};

export const SocialPostThumb = TypedMemo(SocialPostThumbComponent);
